import styled from 'styled-components';

const ContentWrapper = styled.div`
  max-height: 500px;
  overflow: auto;
  position: relative;
  width: 100%;
`;
export { ContentWrapper };
